export default __webpack_public_path__ + "90d12117b5181e9efae081a03fe5b12d.svg";